import { Component, Input, OnInit, OnDestroy, ViewEncapsulation, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { EndoDiagnosisDataModel } from './models/endo-diagnosis-data.model';
import { DiagnosisService } from '../../../../services/form/diagnosis.service';
import { Globals } from '../../../../globals';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { Constants, customFormDiagnosis } from '../../../../constants';
import { MatRadioChange } from '@angular/material/radio';
import { MessagingService } from '../../../../services/messaging.service';
import { MessagingConstants } from '../../../../models/MessagingConstants';
import { PatientCaseWorkItemFormDataModel } from '../../../../models/forms/data/patient-case-work-item-form-data.model';
import { EnumValidValueItemModel } from '../../../../models/enum/enum-valid-value-item.model';
import { StaticDataService } from '../../../../services/static-data.service';
import { ToothService } from '../../../../services/tooth.service';
import { ToothConfigurationModel } from '../../../../models/teeth/tooth-configuration.model';
import { ToothSurfaceConfigurationModel } from '../../../../models/teeth/tooth-surface-configuration.model';
import { EndoDiagnosisToothDetailDataModel } from './models/endo-diagnosis-tooth-detail-data.model';
import { EndoDiagnosisToothDetailScDataModel } from './models/endo-diagnosis-tooth-detail-sc-data.model';
import { ToothCanalConfigurationModel } from '../../../../models/configuration/tooth-canal-configuration.model';
import { DialogService } from '../../../../services/dialog.service';
import { DiagnosisEcirDialogComponent } from './dialogs/diagnosis-ecir-dialog/diagnosis-ecir-dialog.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DiagnosisTriDialogComponent } from './dialogs/diagnosis-tri-dialog/diagnosis-tri-dialog.component';
import { TreatmentFracturesDialogComponent } from '../../../treatment/dialogs/treatment-fractures-dialog/treatment-fractures-dialog.component';
import { TreatmentPerforationDialogComponent } from '../../../treatment/dialogs/treatment-perforation-dialog/treatment-perforation-dialog.component';
import { DiagnosisLymphadenopathyDialogComponent } from './dialogs/diagnosis-lymphadenopathy-dialog/diagnosis-lymphadenopathy-dialog.component';
import { DiagnosisSoftTissueDialogComponent } from './dialogs/diagnosis-soft-tissue-dialog/diagnosis-soft-tissue-dialog.component';
import { DiagnosisDifficultyConfigurationComponent } from '../../../configuration/forms/diagnosis-difficulty-configuration/diagnosis-difficulty-configuration.component';
import { DiagnosisDifficultyConfigurationModel } from '../../../../models/forms/custom/diagnosis/diagnosis-difficulty-configuration.model';
import { DiagnosisPriorQaDialogComponent } from './dialogs/diagnosis-prior-qa-dialog/diagnosis-prior-qa-dialog.component';
import { EndoDiagnosisPriorTreatmentDataModel } from './models/endo-diagnosis-prior-treatment-data.model';
import { EndoMultiToothExamDataModel } from '../../../../models/forms/custom/mti/endo-multi-tooth-exam-data.model';
import { MtiTeethDialogComponent } from '../mti/dialog/mti-teeth-dialog/mti-teeth-dialog.component';
import { MtiService } from '../../../../services/form/mti.service';
import { TdoUserConfigurationModel } from '../../../../models/configuration/user/tdo-user-configuration.model';
import { UserService } from '../../../../services/user.service';
import { TdoDropdownChange } from '../../../../tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { TreatmentEndoPerforationDataModel } from '../../../treatment/models/treatment-endo-perforation-data.model';
import { TreatmentService } from '../../../../services/treatment.service';
import { DiagnosisCloneDialogComponent } from './dialogs/diagnosis-clone-dialog/diagnosis-clone-dialog.component';
import { DataPatientCaseWorkItemModel } from '../../../../models/accountsReceivable/data-patient-case-work-item.model';
import { NotesService } from '../../../../services/notes.service';
import { TdoNoteQueryModel } from '../../../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import { NoteCategoryEnum } from '../../../../models/enum/note-category.enum';
import { NoteTypeEnum } from '../../../../models/enum/note-type.enum';
import { DiagnosisUtils } from './utils/diagnosis-utils';
import { TreatmentFracturesModel } from '../../../treatment/models/treatment-fractures.model';
import {
    TdoNoteAssociatedObject,
    TdoNoteSaveModel
} from '../../../../main-interface/controls/tdo-notes/models/tdo-note-save-model';
import { getMatIconFailedToSanitizeLiteralError } from "@angular/material/icon";
import { forkJoin, ReplaySubject, Subject } from 'rxjs';
import { switchMap, debounceTime, take } from 'rxjs/operators';


@Component({
    standalone: false,
    selector: 'app-diagnosis',
    templateUrl: './diagnosis.component.html',
    styleUrls: ['./diagnosis.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class DiagnosisComponent implements OnInit, OnDestroy, OnChanges {
    ngOnChanges(changes: SimpleChanges) {
        if (changes.caseWorkItemFormsId) {
            this.loadData();
        }
    }
    @Input() caseWorkItemFormsId: string;
    @Input() form: PatientCaseWorkItemFormDataModel;
    @Input() caseWorkItem: DataPatientCaseWorkItemModel;

    isLoading = true;
    private enumsReady$ = new ReplaySubject<void>(1);
    diagModel: EndoDiagnosisDataModel;
    cfgTeeth: ToothConfigurationModel[];
    tooth: ToothConfigurationModel;

    toothSurfaceEnums: EnumValidValueItemModel[] = [];
    toothCanalEnums: EnumValidValueItemModel[] = [];
    probingDepthEnums: EnumValidValueItemModel[] = [];

    SURFACE_ENUM = '00000408-1000-0000-0000-000000000001';
    CANAl_ENUM = '00000408-1000-0000-0000-000000000002';

    configs: DiagnosisDifficultyConfigurationModel[] = [];
    priorTreatments: EndoDiagnosisPriorTreatmentDataModel[] = [];
    assistants: TdoUserConfigurationModel[] = [];
    assistantPredicate: (data: TdoUserConfigurationModel) => string;
    repaPerforationModel: TreatmentEndoPerforationDataModel;
    retrPerforationModel: TreatmentEndoPerforationDataModel;
    cetrFractures: TreatmentFracturesModel[];

    isViewRadio: boolean = true;
    isViewClinical: boolean = false;
    isViewImageing: boolean = true;
    viewSelection: string = '1';
    cariesSavingIDs = new Set<string>();
    subgingDecaySavingIDs = new Set<string>();
    diffuseLucencySavingIDs = new Set<string>();
    circumLucencySavingIDs = new Set<string>();

    datemask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];

    // Save queue configuration
    private readonly SAVE_DEBOUNCE_TIME = 500; // milliseconds
    private saveQueue$ = new Subject<void>();

    constructor(private diagnosisService: DiagnosisService,
        private notesService: NotesService,
        private dialog: MatDialog,
        private staticDataService: StaticDataService,
        private globals: Globals,
        private toothService: ToothService,
        private mtiService: MtiService,
        private userService: UserService,
        private treatmentService: TreatmentService,
        private messagingService: MessagingService,
        private dateAdapter: DateAdapter<Date>,
        private readonly cdr: ChangeDetectorRef) {

        this.dateAdapter.setLocale('en-US'); // dd/MM/yyyy

    }

    ngOnInit(): void {
        this.assistantPredicate = (data: TdoUserConfigurationModel) => data.FirstName + ' ' + data.LastName;

        // Set up save queue with debouncing and switchMap to handle queuing
        this.saveQueue$.pipe(
            debounceTime(this.SAVE_DEBOUNCE_TIME), // Debounce for configured time - wait for user to stop making changes
            switchMap(() => this.diagnosisService.saveDiagnosis(this.diagModel))
        ).subscribe((res) => {
            this.calculateDifficulty();
        });

        if (this.staticDataService.isReady) {
            this.setupEnums();
        } else {
            this.staticDataService.validValuesReadyEvent.subscribe({
                complete: () => {
                    this.setupEnums();
                }
            });
        }
    }

    ngOnDestroy(): void {
        // Clean up the save queue subscription
        this.saveQueue$.complete();
        this.enumsReady$.complete();
    }

    private setupEnums() {
        this.toothSurfaceEnums = this.staticDataService.getValidValueItemsByValidValueName('enumToothSurface');
        this.toothCanalEnums = this.staticDataService.getValidValueItemsByValidValueName('enumToothCanal');
        this.probingDepthEnums = this.staticDataService.getValidValueItemsByValidValueName('enumProbingDepth');

        forkJoin({
            assistants: this.userService.getAssistantUsers(this.globals.TDOCID),
            teeth: this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping),
        }).subscribe({
            next: ({ assistants, teeth }) => {
                this.assistants = assistants.sort((a, b) => (a.FirstName ?? '').toLocaleLowerCase().localeCompare((b.FirstName ?? '').toLocaleLowerCase()));
                this.cfgTeeth = teeth;
                this.enumsReady$.next();
            },
            error: (error) => {
                console.error('DiagnosisComponent setupEnums error:', error);
                this.enumsReady$.error(error);
            },
        });
    }

    loadData() {
        this.isLoading = true;
        this.enumsReady$.pipe(take(1)).subscribe({
            next: () => this.fetchDiagnosis(),
            error: () => { this.isLoading = false; this.cdr.detectChanges(); },
        });
    }

    private fetchDiagnosis() {
        // TODO: Remove this hard-coding in favor of form tooth data.
        //this.tooth = this.cfgTeeth.find(p => p.ToothId.toUpperCase() === 'A0000000-1000-0000-0000-000000000001');
        this.diagnosisService.getDiagnosis(this.globals.currentPatientId, this.caseWorkItemFormsId).subscribe({
            next: (res) => {
            this.diagModel = res;
            //console.log('this.diagModel',this.diagModel);
            this.tooth = this.cfgTeeth.find(p => p.ToothId.toUpperCase() === this.diagModel.ToothId.toUpperCase());

            if (this.diagModel.repa_RootPerforation_TretmentPerfID) {
                this.treatmentService.getTreatmentPerforation(this.diagModel.repa_RootPerforation_TretmentPerfID).subscribe((res1) => {
                    this.repaPerforationModel = res1;
                });
            }

            if (this.diagModel.retr_RootPerforation_TretmentPerfID) {
                this.treatmentService.getTreatmentPerforation(this.diagModel.retr_RootPerforation_TretmentPerfID).subscribe((res1) => {
                    this.retrPerforationModel = res1;
                });
            }



            this.treatmentService.getFractures(this.caseWorkItem.dataPatientCaseItemTeeth[0].CaseWorkItemToothId).subscribe((res2) => {
                this.cetrFractures = res2;
                this.isLoading = false;
            });

            if (this.diagModel) {
                const noteQueryModel = new TdoNoteQueryModel();
                noteQueryModel.parentObjectName = 'dataEndoDiagnosis';
                noteQueryModel.objectId = this.diagModel.EndoDiagID;
                noteQueryModel.patientId = this.globals.currentPatientId;
                noteQueryModel.categoryEnumId = NoteCategoryEnum.DiagnosisPageSummary;
                noteQueryModel.typeEnumId = NoteTypeEnum.Case;
                this.notesService.changeNoteQuery(noteQueryModel);
            }
            this.diagnosisService.getConfigs().subscribe((configRes) => {
                this.configs = configRes;
                this.calculateDifficulty();

                this.diagnosisService.getPriorTreatments(this.diagModel.EndoDiagID).subscribe((prior) => {
                    this.priorTreatments = prior;
                    this.isLoading = false;
                });

            });
            setTimeout(() => {
                this.messagingService.sendComponentMessage(MessagingConstants.NOTES_MINIMIZE, {});
                this.messagingService.sendComponentMessage(MessagingConstants.HEADER_MINIMIZE, {});
            }, 500);
        },
        error: (error) => {
            console.error('DiagnosisComponent loadData error:', error);
            this.isLoading = false;
            this.cdr.detectChanges();
        },
    });
    }

    save() {
        // Emit to the save queue - switchMap will cancel previous requests and only process the latest
        this.saveQueue$.next();
    }

    onBooleanChange(event: MatCheckboxChange, property: string, relatedProperty: string = null) {
        let isWaitingForDetailSave = false;
        if (event.checked) {
            if (property === 'retr_isCrounFeacture_Q') {
                this.diagModel.retr_isCrounFeac = true;
            } else if (property.includes('_Q')) {
                const parentProperty = property.replace('_Q', '');
                this.diagModel[parentProperty] = true;
            }
        } else {
            // Check if unchecked box has a corresponding _Q
            if (this.diagModel[property + '_Q']) {
                this.diagModel[property + '_Q'] = false;
            }

            if (property === 'retr_isCalcification') {
                this.diagModel.retr_Calcification = null;
                this.diagModel.retr_enumDiagCalcificationID = null;
            } else if (property === 'reb_isDiffuseLucency') {
                // Get detauls for diffuse lucency
                const detail = this.diagModel.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === 'reb_DiffuseLucency');
                for (const d of detail.dataEndoDiagnosisToothDetailSCs) {
                    d.isSelected = false;
                }
                this.diagModel.reb_enumDiagLucency_DiffuseID = null;
                isWaitingForDetailSave = true;
                this.diagnosisService.saveDiagnosisDetail(detail).subscribe((res1) => {
                    isWaitingForDetailSave = false;
                });
            } else if (property === 'reb_isCircumLucency') {
                // Get detauls for cir lucency
                const detail = this.diagModel.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === 'reb_CircumLucency');
                for (const d of detail.dataEndoDiagnosisToothDetailSCs) {
                    d.isSelected = false;
                }
                this.diagModel.reb_enumDiagLucency_CircumID = null;
                isWaitingForDetailSave = true;
                this.diagnosisService.saveDiagnosisDetail(detail).subscribe((res1) => {
                    isWaitingForDetailSave = false;
                });
            } else if (property === 'cetr_isCaries') {
                const detail = this.diagModel.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === 'cetr_Caries');
                for (const d of detail.dataEndoDiagnosisToothDetailSCs) {
                    d.isSelected = false;
                }
                isWaitingForDetailSave = true;
                this.diagnosisService.saveDiagnosisDetail(detail).subscribe((res1) => {
                    isWaitingForDetailSave = false;
                });
            } else if (property === 'cetr_isSubgingDecay') {
                const detail = this.diagModel.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === 'cetr_SubgingDecay');
                for (const d of detail.dataEndoDiagnosisToothDetailSCs) {
                    d.isSelected = false;
                }
                isWaitingForDetailSave = true;
                this.diagnosisService.saveDiagnosisDetail(detail).subscribe((res1) => {
                    isWaitingForDetailSave = false;
                });
            } else if (property === 'repa_isIncompleteInadequateRCT') {
                this.diagModel.repa_enumDiagIncompleteInadequateRCT_1ID = null;
                this.diagModel.repa_enumDiagIncompleteInadequateRCT_2ID = null;
                this.diagModel.repa_enumDiagIncompleteInadequateRCT_3ID = null;
            } else if (property === 'cetr_isDefectiveRestorations') {
                this.diagModel.cetr_enumDiagDefectiveRestorationsID = null;
            } else if (property === 'cetr_isBrCrLoose') {
                this.diagModel.cetr_enumDiagBrCRID = null;
            } else if (property === 'cest_isEOSwelling') {
                this.diagModel.cest_isEOSwelling_Fluctuant = false;
                this.diagModel.cest_isEOSwelling_Indurated = false;
                this.diagModel.cest_isEOSwelling_SinusTrack = false;
            } else if (property === 'cest_isIOSwelling') {
                this.diagModel.cest_isIOSwelling_Fluctuant = false;
                this.diagModel.cest_isIOSwelling_Indurated = false;
                this.diagModel.cest_isIOSwelling_DrainingThruSulcus = false;
            } else if (property === 'cest_isSinusTrack') {
                this.diagModel.cest_isSinusTrack_B = false;
                this.diagModel.cest_isSinusTrack_L = false;
                this.diagModel.cest_isSinusTrack_Sulcus = false;
                this.diagModel.cest_enumDiagSinusTrackTimeID = null;
            } else if (property === 'cest_isGingivalRecession') {
                this.diagModel.cest_enumDiagGingivalRecession_BID = null;
                this.diagModel.cest_enumDiagGingivalRecession_LID = null;
                this.diagModel.cest_enumDiagSoftTissueID = null;
            } else if (property === 'cest_isPriorPerioSurgery') {
                this.diagModel.cest_PriorPerioSurgeryDate = null;
            } else if (property === 'cest_isPriorIandD') {
                this.diagModel.cest_PriorIandDdate = null;
            }

            if (relatedProperty) {
                this.diagModel[relatedProperty] = null;
            }
        }

        this.diagModel[property] = event.checked;
        const ivl = setInterval(() => {
            if (!isWaitingForDetailSave) {
                this.save();
                clearInterval(ivl);
            }
        }, 200);
    }

    onRadioGroupChange(event: MatRadioChange, property: string) {
        if (property === 'retr_Calcification') {
            this.diagModel.retr_isCalcification = true;
        }
        this.diagModel[property] = event.value;
        this.save();
    }

    getCanalName(enumToothCanalID: string) {
        if (this.toothCanalEnums) {
            const enu = this.toothCanalEnums.find(p => p.ValidValueItemId === enumToothCanalID);
            if (enu) {
                return enu.ItemSValue;
            }
        }
        return '';
    }

    getSurfaceName(enumToothSurfaceID: string) {
        if (this.toothSurfaceEnums) {
            const enu = this.toothSurfaceEnums.find(p => p.ValidValueItemId === enumToothSurfaceID);
            if (enu) {
                return enu.ItemSValue;
            }
        }
        return '';
    }

    isCanalChecked(typ: string, t: ToothCanalConfigurationModel) {
        const detail = this.diagModel.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === typ);
        if (detail) {
            const detailSc = detail.dataEndoDiagnosisToothDetailSCs.find(p => p.enumToothCanalID === t.enumToothCanalID);
            if (detailSc && detailSc.isSelected) {
                return true;
            }
        }

        return false;
    }

    isSurfaceChecked(typ: string, t: ToothSurfaceConfigurationModel) {
        const detail = this.diagModel.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === typ);
        if (detail) {
            const detailSc = detail.dataEndoDiagnosisToothDetailSCs.find(p => p.enumToothSurfaceID === t.enumToothSurfaceID);
            if (detailSc && detailSc.isSelected) {
                return true;
            }
        }

        return false;
    }

    onDiffuseLucencyChange(event: MatCheckboxChange, t: ToothCanalConfigurationModel) {
        this.diffuseLucencySavingIDs.add(t.enumToothCanalID);
        let detail = this.diagModel.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === 'reb_DiffuseLucency');
        let detailSc: EndoDiagnosisToothDetailScDataModel;

        if (!detail) {
            detail = new EndoDiagnosisToothDetailDataModel();
            detail.EndoDiagID = this.diagModel.EndoDiagID;
            detail.ParentFieldName = 'reb_DiffuseLucency';
            detail.dataEndoDiagnosisToothDetailSCs = [];

            detailSc = new EndoDiagnosisToothDetailScDataModel();
            detailSc.enumToothCanalID = t.enumToothCanalID;
            detailSc.enumDiagSurfaceORCanalD = this.CANAl_ENUM;
            detailSc.isSelected = true;
            detail.dataEndoDiagnosisToothDetailSCs.push(detailSc);
        }

        detailSc = detail.dataEndoDiagnosisToothDetailSCs.find(p => p.enumToothCanalID === t.enumToothCanalID);
        if (detailSc) {
            detailSc.isSelected = event.checked;
        } else {
            detailSc = new EndoDiagnosisToothDetailScDataModel();
            detailSc.enumToothCanalID = t.enumToothCanalID;
            detailSc.enumDiagSurfaceORCanalD = this.CANAl_ENUM;
            detailSc.isSelected = true;
            detail.dataEndoDiagnosisToothDetailSCs.push(detailSc);
        }

        this.diagnosisService.saveDiagnosisDetail(detail).subscribe({
            next: (res) => {
                const detIndex = this.diagModel.dataEndoDiagnosisToothDetails.findIndex(p => p.ParentFieldName === 'reb_DiffuseLucency');
                if (detIndex === -1) {
                    this.diagModel.dataEndoDiagnosisToothDetails.push(res);
                } else {
                    this.diagModel.dataEndoDiagnosisToothDetails[detIndex] = res;
                }
                if (event.checked) {
                    this.diagModel.reb_isDiffuseLucency = true;
                    this.save();
                }
                this.diffuseLucencySavingIDs.delete(t.enumToothCanalID);
                const viewRef = this.cdr as any;
                if (!viewRef.destroyed) {
                    this.cdr.detectChanges();
                }
            },
            error: () => {
                this.diffuseLucencySavingIDs.delete(t.enumToothCanalID);
                const viewRef = this.cdr as any;
                if (!viewRef.destroyed) {
                    this.cdr.detectChanges();
                }
            }
        });
    }

    onCircumLucencyChange(event: MatCheckboxChange, t: ToothCanalConfigurationModel) {
        this.circumLucencySavingIDs.add(t.enumToothCanalID);
        let detail = this.diagModel.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === 'reb_CircumLucency');
        let detailSc: EndoDiagnosisToothDetailScDataModel;
        if (!detail) {
            detail = new EndoDiagnosisToothDetailDataModel();
            detail.EndoDiagID = this.diagModel.EndoDiagID;
            detail.ParentFieldName = 'reb_CircumLucency';
            detail.dataEndoDiagnosisToothDetailSCs = [];

            detailSc = new EndoDiagnosisToothDetailScDataModel();
            detailSc.enumToothCanalID = t.enumToothCanalID;
            detailSc.enumDiagSurfaceORCanalD = this.CANAl_ENUM;
            detailSc.isSelected = true;
            detail.dataEndoDiagnosisToothDetailSCs.push(detailSc);
        }

        detailSc = detail.dataEndoDiagnosisToothDetailSCs.find(p => p.enumToothCanalID === t.enumToothCanalID);
        if (detailSc) {
            detailSc.isSelected = event.checked;
        } else {
            detailSc = new EndoDiagnosisToothDetailScDataModel();
            detailSc.enumToothCanalID = t.enumToothCanalID;
            detailSc.enumDiagSurfaceORCanalD = this.CANAl_ENUM;
            detailSc.isSelected = true;
            detail.dataEndoDiagnosisToothDetailSCs.push(detailSc);
        }

        this.diagnosisService.saveDiagnosisDetail(detail).subscribe({
            next: (res) => {
                const detIndex = this.diagModel.dataEndoDiagnosisToothDetails.findIndex(p => p.ParentFieldName === 'reb_CircumLucency');
                if (detIndex === -1) {
                    this.diagModel.dataEndoDiagnosisToothDetails.push(res);
                } else {
                    this.diagModel.dataEndoDiagnosisToothDetails[detIndex] = res;
                }
                if (event.checked) {
                    this.diagModel.reb_isCircumLucency = true;
                    this.save();
                }
                this.circumLucencySavingIDs.delete(t.enumToothCanalID);
                const viewRef = this.cdr as any;
                if (!viewRef.destroyed) {
                    this.cdr.detectChanges();
                }
            },
            error: () => {
                this.circumLucencySavingIDs.delete(t.enumToothCanalID);
                const viewRef = this.cdr as any;
                if (!viewRef.destroyed) {
                    this.cdr.detectChanges();
                }
            }
        });
    }

    onCariesChange(event: MatCheckboxChange, t: ToothSurfaceConfigurationModel) {
        this.cariesSavingIDs.add(t.enumToothSurfaceID);
        let detail = this.diagModel.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === 'cetr_Caries');
        let detailSc: EndoDiagnosisToothDetailScDataModel;
        if (!detail) {
            detail = new EndoDiagnosisToothDetailDataModel();
            detail.EndoDiagID = this.diagModel.EndoDiagID;
            detail.ParentFieldName = 'cetr_Caries';
            detail.dataEndoDiagnosisToothDetailSCs = [];

            detailSc = new EndoDiagnosisToothDetailScDataModel();
            detailSc.enumToothSurfaceID = t.enumToothSurfaceID;
            detailSc.enumDiagSurfaceORCanalD = this.SURFACE_ENUM;
            detailSc.isSelected = true;
            detail.dataEndoDiagnosisToothDetailSCs.push(detailSc);
        }

        detailSc = detail.dataEndoDiagnosisToothDetailSCs.find(p => p.enumToothSurfaceID === t.enumToothSurfaceID);
        if (detailSc) {
            detailSc.isSelected = event.checked;
        } else {
            detailSc = new EndoDiagnosisToothDetailScDataModel();
            detailSc.enumToothSurfaceID = t.enumToothSurfaceID;
            detailSc.enumDiagSurfaceORCanalD = this.SURFACE_ENUM;
            detailSc.isSelected = true;
            detail.dataEndoDiagnosisToothDetailSCs.push(detailSc);
        }

        this.diagnosisService.saveDiagnosisDetail(detail).subscribe({
            next: (res) => {
                const detIndex = this.diagModel.dataEndoDiagnosisToothDetails.findIndex(p => p.ParentFieldName === 'cetr_Caries');
                if (detIndex === -1) {
                    this.diagModel.dataEndoDiagnosisToothDetails.push(res);
                } else {
                    this.diagModel.dataEndoDiagnosisToothDetails[detIndex] = res;
                }
                if (event.checked) {
                    this.diagModel.cetr_isCaries = true;
                    this.save();
                }
                this.cariesSavingIDs.delete(t.enumToothSurfaceID);
                const viewRef = this.cdr as any;
                if (!viewRef.destroyed) {
                    this.cdr.detectChanges();
                }
            },
            error: () => {
                this.cariesSavingIDs.delete(t.enumToothSurfaceID);
                const viewRef = this.cdr as any;
                if (!viewRef.destroyed) {
                    this.cdr.detectChanges();
                }
            }
        });
    }

    onSubgingDecayChange(event: MatCheckboxChange, t: ToothSurfaceConfigurationModel) {
        this.subgingDecaySavingIDs.add(t.enumToothSurfaceID);
        let detail = this.diagModel.dataEndoDiagnosisToothDetails.find(p => p.ParentFieldName === 'cetr_SubgingDecay');
        let detailSc: EndoDiagnosisToothDetailScDataModel;
        if (!detail) {
            detail = new EndoDiagnosisToothDetailDataModel();
            detail.EndoDiagID = this.diagModel.EndoDiagID;
            detail.ParentFieldName = 'cetr_SubgingDecay';
            detail.dataEndoDiagnosisToothDetailSCs = [];

            detailSc = new EndoDiagnosisToothDetailScDataModel();
            detailSc.enumToothSurfaceID = t.enumToothSurfaceID;
            detailSc.enumDiagSurfaceORCanalD = this.SURFACE_ENUM;
            detailSc.isSelected = true;
            detail.dataEndoDiagnosisToothDetailSCs.push(detailSc);
        }

        detailSc = detail.dataEndoDiagnosisToothDetailSCs.find(p => p.enumToothSurfaceID === t.enumToothSurfaceID);
        if (detailSc) {
            detailSc.isSelected = event.checked;
        } else {
            detailSc = new EndoDiagnosisToothDetailScDataModel();
            detailSc.enumToothSurfaceID = t.enumToothSurfaceID;
            detailSc.enumDiagSurfaceORCanalD = this.SURFACE_ENUM;
            detailSc.isSelected = true;
            detail.dataEndoDiagnosisToothDetailSCs.push(detailSc);
        }

        this.diagnosisService.saveDiagnosisDetail(detail).subscribe({
            next: (res) => {
                const detIndex = this.diagModel.dataEndoDiagnosisToothDetails.findIndex(p => p.ParentFieldName === 'cetr_SubgingDecay');
                if (detIndex === -1) {
                    this.diagModel.dataEndoDiagnosisToothDetails.push(res);
                } else {
                    this.diagModel.dataEndoDiagnosisToothDetails[detIndex] = res;
                }
                if (event.checked) {
                    this.diagModel.cetr_isSubgingDecay = true;
                    this.save();
                }
                this.subgingDecaySavingIDs.delete(t.enumToothSurfaceID);
                const viewRef = this.cdr as any;
                if (!viewRef.destroyed) {
                    this.cdr.detectChanges();
                }
            },
            error: () => {
                this.subgingDecaySavingIDs.delete(t.enumToothSurfaceID);
                const viewRef = this.cdr as any;
                if (!viewRef.destroyed) {
                    this.cdr.detectChanges();
                }
            }
        });
    }

    onSoftTissueDateChange1(event: any) {
        this.diagModel.cest_isSoftTissueExam = true;
        console.log(this.diagModel.cest_SoftTissueExamDate);
        this.diagModel.cest_SoftTissueExamDate = new Date(event).toLocaleDateString();
        //setTimeout(() => {
        this.save();
        // this.diagModel.retr_RootPerforation_TretmentPerfID
        //}, 400);
    }

    openEcirDialog(property: string) {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        this.dialog.open(DiagnosisEcirDialogComponent, config).afterClosed().subscribe((res) => {
            if (res) {
                this.diagModel.retr_enumDiagECIRID = res;
                this.save();
            }
        });
    }

    openTriDialog() {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        this.dialog.open(DiagnosisTriDialogComponent, config);
    }

    openFracturesDialog() {
        /* const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        this.dialog.open(TreatmentFracturesDialogComponent, config);*/
        const dialogRef = this.dialog.open(TreatmentFracturesDialogComponent, {
            width: '1000px',
            height: '600px',
            panelClass: 'dialog',
            data: { CaseWorkItemToothId: this.form.dataPatientCaseItemFormTeeth[0].CaseWorkItemToothId, toothNum: this.form.dataPatientCaseItemFormTeeth[0].Notation }
        }).afterClosed().subscribe((res) => {
            // The dialog returns only persisted fractures, so an empty array means the user
            // confirmed without saving one - or deleted the last one - and the indicator must
            // be cleared. A cancelled dialog returns nothing and leaves the indicator alone.
            if (!res) {
                return;
            }
            const hasFractures = res.length > 0;
            if (!!this.diagModel.catr_isFractures !== hasFractures) {
                this.diagModel.catr_isFractures = hasFractures;
                this.save();
            }
        });
    }

    openRootPerforationDialog(property: string) {
        if (property.includes('repa')) {
            if (!this.repaPerforationModel && this.diagModel.repa_RootPerforation_TretmentPerfID) {
                this.treatmentService.getTreatmentPerforation(this.diagModel.repa_RootPerforation_TretmentPerfID).subscribe((res1) => {
                    this.repaPerforationModel = res1;
                    this.openRPD(property);
                });
            } else {
                this.openRPD(property);
            }
        } else if (property.includes('retr')) {
            if (!this.retrPerforationModel && this.diagModel.retr_RootPerforation_TretmentPerfID) {
                this.treatmentService.getTreatmentPerforation(this.diagModel.retr_RootPerforation_TretmentPerfID).subscribe((res2) => {
                    this.retrPerforationModel = res2;
                    this.openRPD(property);
                });
            } else {
                this.openRPD(property);
            }
        }
    }

    openRPD(property: string) {
        const toothNum = this.caseWorkItem?.dataPatientCaseItemTeeth[0].Notation;
        let rpm = [this.repaPerforationModel];
        if (!this.repaPerforationModel) {
            rpm = null;
        }
        let retr = [this.retrPerforationModel];
        if (!this.retrPerforationModel) {
            retr = null;
        }
        if (property.includes('repa')) {
            const dialogRef = this.dialog.open(TreatmentPerforationDialogComponent, {
                width: '1100px',
                height: '700px',
                panelClass: 'dialog',
                data: { perforationModels: rpm, classType: '00000153-1000-0000-0000-000000000001', toothNum }
            });
            dialogRef.afterClosed().subscribe((res) => {
                if (res) {
                    const perf = res[0] as TreatmentEndoPerforationDataModel;
                    this.diagModel.repa_RootPerforation_TretmentPerfID = perf.TretmentPerfID;
                    this.repaPerforationModel = res[0];
                    this.save();
                    // Save id to model
                }
            });
        } else if (property.includes('retr')) {
            const dialogRef = this.dialog.open(TreatmentPerforationDialogComponent, {
                width: '1100px',
                height: '700px',
                panelClass: 'dialog',
                data: { perforationModels: retr, classType: '00000153-1000-0000-0000-000000000001', toothNum }
            });
            dialogRef.afterClosed().subscribe((res) => {
                if (res) {
                    const perf = res[0] as TreatmentEndoPerforationDataModel;
                    this.diagModel.retr_RootPerforation_TretmentPerfID = perf.TretmentPerfID;
                    this.retrPerforationModel = res[0];
                    this.save();
                    // Save id to model
                }
            });
        }
    }

    openLymphDialog() {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        this.dialog.open(DiagnosisLymphadenopathyDialogComponent, config);
    }

    getDate(d: string) {
        if (d === null) {
            return null;
        } else {
            const dat = new Date(d);
            if (dat) {
                return dat.toLocaleDateString();
            }
        }

        return '';
    }


    onCompleteDateChange(e) {
        // console.log(e);
        this.diagModel.thisDiagnosisCompleted = e.target.value;
        this.save();
    }


    openSoftTissueDialog() {
        // get original first
        const zOri = JSON.parse(JSON.stringify(this.diagModel));

        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = this.diagModel;
        this.dialog.open(DiagnosisSoftTissueDialogComponent, config).afterClosed().subscribe((res) => {
            if (res) {
                this.diagModel.cest_isSoftTissueExam = true;
                this.save();
            }
            else {
                // restore original
                this.diagModel.cest_STE_enumDiagSTEOropharynxID = zOri.cest_STE_enumDiagSTEOropharynxID;

                this.diagModel.cest_STE_enumDiagSTEFaceID = zOri.cest_STE_enumDiagSTEFaceID;
                this.diagModel.cest_STE_enumDiagSTENeckID = zOri.cest_STE_enumDiagSTENeckID;
                this.diagModel.cest_STE_enumDiagSTELipsID = zOri.cest_STE_enumDiagSTELipsID;
                this.diagModel.cest_STE_enumDiagSTETongueID = zOri.cest_STE_enumDiagSTETongueID;
                this.diagModel.cest_STE_enumDiagSTEFloorOfMouthID = zOri.cest_STE_enumDiagSTEFloorOfMouthID;
                this.diagModel.cest_STE_enumDiagSTEAlveolarMucosaID = zOri.cest_STE_enumDiagSTEAlveolarMucosaID;
                this.diagModel.cest_STE_enumDiagSTEHardPlateID = zOri.cest_STE_enumDiagSTEHardPlateID;
                this.diagModel.cest_STE_enumDiagSTESoftPlateID = zOri.cest_STE_enumDiagSTESoftPlateID;
                this.diagModel.cest_STE_enumDiagSTEGingivaID = zOri.cest_STE_enumDiagSTEGingivaID;
                this.diagModel.cest_STE_enumDiagSTELingAttachGingivaID = zOri.cest_STE_enumDiagSTELingAttachGingivaID;
                this.diagModel.cest_STE_enumDiagSTEBuccalAttachGingivaID = zOri.cest_STE_enumDiagSTEBuccalAttachGingivaID;
                this.diagModel.cest_STE_enumDiagSTEOropharynxID = zOri.cest_STE_enumDiagSTEOropharynxID;




            }
        });
    }

    calculateDifficulty() {
        this.diagModel.DifficultyLevel = 0;
        Object.entries(this.diagModel).forEach(
            ([key, value]) => {
                const diffConf = this.configs.find(p => p.FieldName === key);
                if (key.includes('_is')) {
                    if (diffConf && value === true) {
                        this.diagModel.DifficultyLevel += diffConf.DifficultyLevel;
                    }
                }

                if (key.includes('_enum')) {
                    if (diffConf && value !== null && value !== Constants.emptyGuid) {
                        const enu = diffConf.cfgDiagnosisDifficultyEnums.find(p => p.ValidValueItemID.toLowerCase() === (value as string).toLowerCase());
                        if (enu) {
                            this.diagModel.DifficultyLevel += enu.DifficultyLevel;
                        }
                    }
                }
            }
        );
        this.diagnosisService.saveDiagnosis(this.diagModel).subscribe((res) => {
            //
        });
    }

    openPriorQa() {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = { data: this.diagModel, configs: this.configs };
        this.dialog.open(DiagnosisPriorQaDialogComponent, config).afterClosed().subscribe((res) => {
            if (res) {

            }
        });
    }

    onPriorDateChange(event: any, prior: EndoDiagnosisPriorTreatmentDataModel) {
        prior.TreatmentDate = event;
        this.savePrior(prior);
    }

    savePrior(prior: EndoDiagnosisPriorTreatmentDataModel) {
        this.diagnosisService.savePriorTreatments(prior).subscribe((res) => {
            prior.EndoDiagPriorTretmentID = res.EndoDiagPriorTretmentID;
            prior.xauditDeleted = res.xauditDeleted;
            prior.xauditCreatedOn = res.xauditCreatedOn;
            prior.xauditCreatedBy = res.xauditCreatedBy;
            prior.xauditTableRowID = res.xauditTableRowID;

        });
    }

    deletePrior(prior: EndoDiagnosisPriorTreatmentDataModel) {
        this.diagnosisService.deletePriorTreatments(prior).subscribe((res) => {
            const idx = this.priorTreatments.findIndex(p => p === prior);
            if (idx > -1) {
                this.priorTreatments.splice(idx, 1);
            }
        });
    }

    onAddNewPriorTreatment() {
        const model = new EndoDiagnosisPriorTreatmentDataModel();
        model.EndoDiagID = this.diagModel.EndoDiagID;
        model.xauditDeleted = false;
        model.TreatmentDate = new Date().toLocaleDateString();
        this.priorTreatments.unshift(model);
    }

    onDoctorChange(event: any, prior: EndoDiagnosisPriorTreatmentDataModel) {
        prior.TreatingDoctor = event;
        this.savePrior(prior);
    }

    openTestingDialog() {
        this.mtiService.getSingleTooth(this.diagModel.MTEToothID).subscribe((res) => {
            const exam = new EndoMultiToothExamDataModel();
            exam.MTEID = res.MTEID;
            exam.dataEndoMutiToothExamTeethinExams = [res];

            const config = new MatDialogConfig();
            config.panelClass = 'dialog';
            config.data = { exam };

            this.dialog.open(MtiTeethDialogComponent, config);
        });
    }

    onCompleteDateFocus(e) {
        if (!this.diagModel.thisDiagnosisCompleted || this.diagModel.thisDiagnosisCompleted.length === 0) {
            this.diagModel.thisDiagnosisCompleted = new Date().toLocaleDateString();
            this.completeEndoDiagnosisForm(this.diagModel.EndoDiagID);
            this.save();
            this.onSaveNote();

        }
        e.target.select();


    }

    completeEndoDiagnosisForm(endoDiagId: string) {
        this.diagnosisService.completeEndoDiagnosisForm(endoDiagId).toPromise();
    }

    getDateString(date: string) {
        return new Date(date).toDateString();
    }

    getAssistant(id: string) {
        if (this.assistants) {
            const assis = this.assistants.find(p => p.UserID?.toLowerCase() === id?.toLowerCase());
            if (assis) {
                return assis;
            }
        }

        return null;
    }

    onAssistantChange(event: TdoDropdownChange) {
        this.diagModel.Assistant_UserID = event.value.UserID;
        this.save();
    }

    openCloneDialog() {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';

        const otherDiagnosisForms = this.caseWorkItem.dataPatientCaseItemForms.filter(p => {
            if (p.enumCustomFormID === customFormDiagnosis && p.CaseWorkItemFormsId !== this.form.CaseWorkItemFormsId) {
                return p;
            }
        });

        const sourceDiagnosisForms = this.caseWorkItem.dataPatientCaseItemForms.filter(p => {
            if (p.enumCustomFormID === customFormDiagnosis && p.CaseWorkItemFormsId === this.form.CaseWorkItemFormsId) {
                return p;
            }
        });

        config.data = { sourceDiagnosisId: this.diagModel.CaseWorkItemFormsId, sourceForms: sourceDiagnosisForms };

        this.dialog.open(DiagnosisCloneDialogComponent, config);
    }

    onSaveNote() {
        const assistant = this.assistants.find(p => p.UserID.toLowerCase() === this.diagModel.Assistant_UserID);

        const util = new DiagnosisUtils();
        let val = util.getNoteString(this.diagModel, this.staticDataService, this.retrPerforationModel, this.repaPerforationModel, this.cetrFractures, this.tooth);
        if (assistant) {
            val += '\r\n' + 'Assistant: ' + assistant?.FirstName + ' ' + assistant?.LastName !== null ? assistant?.LastName : '';
        }

        const mod = new TdoNoteSaveModel();
        mod.text = val;
        mod.patientId = this.globals.currentPatientId;

        const assoc = new TdoNoteAssociatedObject();
        assoc.objectId = this.diagModel.EndoDiagID;
        assoc.parentObjectName = 'dataEndoDiagnosis';
        mod.associatedObjects = [];
        mod.associatedObjects.push(assoc);
        mod.categoryEnumIds = [NoteCategoryEnum.DiagnosisPageSummary];
        mod.typeEnumIds = [NoteTypeEnum.Case];
        this.notesService.saveNote(mod).subscribe((res) => {
            //
            this.messagingService.sendComponentMessage(MessagingConstants.NOTES_REFRESH, {});
        });
    }

    onSoftTissueExamDateChanged($event: Date) {
        this.diagModel.cest_isSoftTissueExam = true;
        this.diagModel.cest_SoftTissueExamDate = $event.toLocaleDateString();
        this.openSoftTissueDialog();
        this.save();
    }


    onSoftTissueDateFocus(e: FocusEvent) {

        if (this.diagModel.cest_SoftTissueExamDate == null) {
            this.diagModel.cest_SoftTissueExamDate = new Date().toLocaleDateString();

            this.save();
        }

        // e.target.select();


    }

    onClickDeletePriorTretment(prior: EndoDiagnosisPriorTreatmentDataModel) {

        prior.xauditDeleted = true;



        this.savePrior(prior);

        // this.priorTreatments

    }
}
